module.exports = __webpack_public_path__ + "img/076c687.jpg";